import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {GameModelEvent} from "@nolimitcity/slot-game/bin/model/GameModel";
import {Logger, LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {GameAssets} from "./GameAssets";
import {Sound} from "./sound/Sound";
import {BackgroundElements} from "./view/BackgroundElements";
import {WinPresentation} from "./gameflow/WinPresentation";
import {NormalBetPresentation} from "./gameflow/NormalBetPresentation";
import {NormalResultPresentation} from "./gameflow/NormalResultPresentation";
import {IdleNormalPresentation} from "./gameflow/IdleNormalPresentation";
import {ZeroBetIdlePresentation} from "./gameflow/ZeroBetIdlePresentation";
import {ISymbolValues, Mental2GameData} from "./server/Data";
import {Model} from "./server/Model";
import {ReelsView} from "./reels/ReelsView";
import {SpineViewUtils} from "./utils/SpineViewUtils";
import {NolimitConfig} from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";
import {BlackBg} from "./view/BlackBg";
import {PostIntro} from "./view/PostIntro";
import {EnhancerView} from "./view/EnhancerView";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {Lift} from "./view/Lift";
import {FSIntroView} from "./view/FSIntroView";
import {FSOutroView} from "./view/FSOutroView";
import {TotalWinView} from "./view/TotalWinView";
import {WinWaysView} from "./view/WinWaysView";
import {FireFrameView} from "./view/FireFrameView";
import {BigWinView} from "./view/BigWinView";
import {WinHighlightView} from "./view/WinHighlightView";
import {GimmeDanger, MyriadPro, RussoOne, Titania} from "./Fonts";
import {EffectsView} from "./view/EffectsView";
import {GraphicsPool} from "./utils/GraphicsPool";
import {WinCapView} from "./view/WinCapView";
import {AnticipationView} from "./view/AnticipationView";
import {SFSIntroView} from "./view/SFSIntroView";
import {SFSOutroView} from "./view/SFSOutroView";
import {CFSIntroView} from "./view/CFSIntroView";
import {CFSOutroView} from "./view/CFSOutroView";
import {GameFeatureMode} from "./enums/Enum";
import {ForeGroundElements} from "./view/ForeGroundElements";
import {StickyView} from "./view/StickyView";
import {UpgradeView} from "./view/UpgradeView";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {TemplateAsset, TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import {
    FeatureBuyTimesBetValue
} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {Skinner} from "@nolimitcity/slot-launcher/bin/utils/Skinner";


export class Game extends SlotGame {
    public static model: Model;
    public static assetLoader: AssetLoader;
    public static soundPlayer: Sound;
    public static backgroundElements: BackgroundElements;
    public static gameFlowController: GameFlowController;
    public static reelView: ReelsView;
    public static blackBG: BlackBg = new BlackBg();
    public static postIntro: PostIntro;
    public static enhancerView: EnhancerView;
    public static lift: Lift;
    public static fsIntroView: FSIntroView;
    public static cfsIntroView: CFSIntroView;
    public static sfsIntroView: SFSIntroView;
    public static fsOutroView: FSOutroView;
    public static cfsOutroView: CFSOutroView;
    public static sfsOutroView: SFSOutroView;
    public static totalWinView: TotalWinView;
    public static winWaysView: WinWaysView;
    public static bigWinView: BigWinView;
    public static fireFrameView: FireFrameView;
    public static winHighlightView: WinHighlightView;
    public static effectsView: EffectsView;
    public static graphicsPool: GraphicsPool;
    public static winCapView: WinCapView;
    public static anticipationView: AnticipationView;
    public static foregroundElements: ForeGroundElements;
    public static stickyView: StickyView;
    public static upgradeView: UpgradeView;
    public static buyFeatureName: string;
    public static idleNormalPresentation: IdleNormalPresentation;
    private _defaultSymbolValues: ISymbolValues = {
        "M1": {
            "3": 10,
            "4": 20,
            "5": 50
        },
        "M2": {
            "3": 9,
            "4": 15,
            "5": 35
        },
        "L2": {
            "3": 5,
            "4": 8,
            "5": 14
        },
        "L3": {
            "3": 4,
            "4": 7,
            "5": 12
        },
        "M4": {
            "3": 7,
            "4": 12,
            "5": 25
        },
        "L4": {
            "3": 3,
            "4": 6,
            "5": 11
        },
        "L1": {
            "3": 6,
            "4": 9,
            "5": 15
        },
        "M3": {
            "3": 8,
            "4": 14,
            "5": 30
        },
        "M5": {
            "3": 6,
            "4": 10,
            "5": 20
        },
        "L5": {
            "3": 2,
            "4": 5,
            "5": 10
        }
    };

    private skinner: Skinner;

    constructor() {
        super();
        const validSkins: string[] = [
            "sweep"
        ]
        this.skinner = new Skinner(validSkins);
    }

    private handleSweepInit() {
        //Making sure that skinID is set based  on "replaceWordFree" gcc.
        if (SlotGame.apiPlugin.gameClientConfiguration.isSet) {
            if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                this.skinner.skinId = "sweep";
            }
        } else {
            SlotGame.apiPlugin.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                    this.skinner.skinId = "sweep";
                }
            })
        }
    }

    private handleSweepGetReady(): Promise<any> {
        if (this.skinner.skinId != undefined) {
            const replaceMap: Map<string, string> = new Map();

            replaceMap.set("BOOSTED_BET_1", "BOOSTED_BET_1.png");
            replaceMap.set("boosted_bet", "boosted_bet.png");
            return this.skinner.loadSkin(replaceMap);
        }
        return Promise.resolve();
    }
    private static getSymbolString(key: string, data: { [numSymbols: number]: number }): string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <div class="payout-group">
                <div class="payout">
                    <span class="number">5</span>
                    <span class="multiplier" data-multiplier="${data[5]}">${data[5]}</span>
                </div>
                <div class="payout">
                    <span class="number">4</span>
                    <span class="multiplier" data-multiplier="${data[4]}">${data[4]}</span>
                </div>
                <div class="payout">
                    <span class="number">3</span>
                    <span class="multiplier" data-multiplier="${data[3]}">${data[3]}</span>
                </div>
            </div>
            </div>
        `;
    }

    public static isSingleWinBelowStake(): boolean {
        return Game.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (Game.model.gameData.totalSpinWinnings <= Game.model.gameData.playedBetValue);
    }

    public static isWinBelowStake(): boolean {
        return this.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (this.model.data.accumulatedRoundWin <= this.getBuyFeaturePrice());
    }

    public static getBuyFeaturePrice(): number {
        const betLevel: string = Game.apiPlugin.freeBets.hasFreeBets() ? Game.apiPlugin.freeBets.getBet() : Game.apiPlugin.betLevel.getLevel();
        let price: number = Game.model.gameData?.playedBetValue || parseFloat(betLevel);
        if (this.buyFeatureName) {
            for (let index: number = 0; index < Game.model.initData.featureBuyTimesBetValue.length; index++) {
                if (Game.model.initData.featureBuyTimesBetValue[index].name === this.buyFeatureName) {
                    price *= Game.model.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return MathHelper.ceilToDecimals(price, 2);
    }

    //to show spine
    public static showSpineUtils(): void {
        if (NolimitConfig.isDevMode) {
            SpineViewUtils.init(GameAssets.RESOURCES_GROUPS.main, Game.assetLoader);
        }
    }

    getNoWinGameData(): any {
        return {
            "reels": [
                [
                    "S1",
                    "L4",
                    "L5"
                ],
                [
                    "S2",
                    "M2"
                ],
                [
                    "L4",
                    "M2",
                    "M3"
                ],
                [
                    "L4",
                    "L2"
                ],
                [
                    "L2",
                    "M2",
                    "M1"
                ]
            ],
            "evaluatedArea": [
                [
                    "S1",
                    "L4",
                    "L5"
                ],
                [
                    "S2",
                    "M2",
                    "BLANK"
                ],
                [
                    "L4",
                    "M2",
                    "M3",
                    "BLANK"
                ],
                [
                    "L4",
                    "L2",
                    "BLANK"
                ],
                [
                    "L2",
                    "M2",
                    "M1"
                ]
            ],
            "betWayWins": [],
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "freespinTriggeredThisSpin": false,
            "featureBuyName": "NORMAL_PLAY",
            "wasFeatureBuy": false,
            "boostedBetPlayed": false,
            "brokeTheBank": false,
            "fireFrames": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "fireReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "finalEvaluatedArea": [
                [
                    [
                        {
                            "sym": "S1",
                            "symFrom": "S1",
                            "symTo": "S1",
                            "size": 1,
                            "multiplier": 1,
                            "wasDead": false,
                            "wasS2": false,
                            "multiplierOccurrence": 0,
                            "cutRecord": [
                                false,
                                false,
                                false,
                                false,
                                false
                            ]
                        }
                    ],
                    [
                        {
                            "sym": "L4",
                            "symFrom": "L4",
                            "symTo": "L4",
                            "size": 1,
                            "multiplier": 1,
                            "wasDead": false,
                            "wasS2": false,
                            "multiplierOccurrence": 0,
                            "cutRecord": [
                                false,
                                false,
                                false,
                                false,
                                false
                            ]
                        }
                    ],
                    [
                        {
                            "sym": "L5",
                            "symFrom": "L5",
                            "symTo": "L5",
                            "size": 1,
                            "multiplier": 1,
                            "wasDead": false,
                            "wasS2": false,
                            "multiplierOccurrence": 0,
                            "cutRecord": [
                                false,
                                false,
                                false,
                                false,
                                false
                            ]
                        }
                    ]
                ],
                [
                    [
                        {
                            "sym": "M3",
                            "symFrom": "M3",
                            "symTo": "M3",
                            "size": 1,
                            "multiplier": 1,
                            "wasDead": false,
                            "wasS2": true,
                            "multiplierOccurrence": 0,
                            "cutRecord": [
                                false,
                                false,
                                false,
                                false,
                                false
                            ]
                        }
                    ],
                    [
                        {
                            "sym": "M2",
                            "symFrom": "M2",
                            "symTo": "M2",
                            "size": 1,
                            "multiplier": 1,
                            "wasDead": false,
                            "wasS2": false,
                            "multiplierOccurrence": 0,
                            "cutRecord": [
                                false,
                                false,
                                false,
                                false,
                                false
                            ]
                        }
                    ],
                    [
                        {
                            "sym": "BLANK",
                            "symFrom": "BLANK",
                            "symTo": "BLANK",
                            "size": 1,
                            "multiplier": 1,
                            "wasDead": false,
                            "wasS2": false,
                            "multiplierOccurrence": 0,
                            "cutRecord": [
                                false,
                                false,
                                false,
                                false,
                                false
                            ]
                        }
                    ]
                ],
                [
                    [
                        {
                            "sym": "L4",
                            "symFrom": "L4",
                            "symTo": "L4",
                            "size": 1,
                            "multiplier": 1,
                            "wasDead": false,
                            "wasS2": false,
                            "multiplierOccurrence": 0,
                            "cutRecord": [
                                false,
                                false,
                                false,
                                false,
                                false
                            ]
                        }
                    ],
                    [
                        {
                            "sym": "M2",
                            "symFrom": "M2",
                            "symTo": "M2",
                            "size": 1,
                            "multiplier": 1,
                            "wasDead": false,
                            "wasS2": false,
                            "multiplierOccurrence": 0,
                            "cutRecord": [
                                false,
                                false,
                                false,
                                false,
                                false
                            ]
                        }
                    ],
                    [
                        {
                            "sym": "M3",
                            "symFrom": "M3",
                            "symTo": "M3",
                            "size": 1,
                            "multiplier": 1,
                            "wasDead": false,
                            "wasS2": false,
                            "multiplierOccurrence": 0,
                            "cutRecord": [
                                false,
                                false,
                                false,
                                false,
                                false
                            ]
                        }
                    ],
                    [
                        {
                            "sym": "BLANK",
                            "symFrom": "BLANK",
                            "symTo": "BLANK",
                            "size": 1,
                            "multiplier": 1,
                            "wasDead": false,
                            "wasS2": false,
                            "multiplierOccurrence": 0,
                            "cutRecord": [
                                false,
                                false,
                                false,
                                false,
                                false
                            ]
                        }
                    ]
                ],
                [
                    [
                        {
                            "sym": "L4",
                            "symFrom": "L4",
                            "symTo": "L4",
                            "size": 1,
                            "multiplier": 1,
                            "wasDead": false,
                            "wasS2": false,
                            "multiplierOccurrence": 0,
                            "cutRecord": [
                                false,
                                false,
                                false,
                                false,
                                false
                            ]
                        }
                    ],
                    [
                        {
                            "sym": "L2",
                            "symFrom": "L2",
                            "symTo": "L2",
                            "size": 1,
                            "multiplier": 1,
                            "wasDead": false,
                            "wasS2": false,
                            "multiplierOccurrence": 0,
                            "cutRecord": [
                                false,
                                false,
                                false,
                                false,
                                false
                            ]
                        }
                    ],
                    [
                        {
                            "sym": "BLANK",
                            "symFrom": "BLANK",
                            "symTo": "BLANK",
                            "size": 1,
                            "multiplier": 1,
                            "wasDead": false,
                            "wasS2": false,
                            "multiplierOccurrence": 0,
                            "cutRecord": [
                                false,
                                false,
                                false,
                                false,
                                false
                            ]
                        }
                    ]
                ],
                [
                    [
                        {
                            "sym": "L2",
                            "symFrom": "L2",
                            "symTo": "L2",
                            "size": 1,
                            "multiplier": 1,
                            "wasDead": false,
                            "wasS2": false,
                            "multiplierOccurrence": 0,
                            "cutRecord": [
                                false,
                                false,
                                false,
                                false,
                                false
                            ]
                        }
                    ],
                    [
                        {
                            "sym": "M2",
                            "symFrom": "M2",
                            "symTo": "M2",
                            "size": 1,
                            "multiplier": 1,
                            "wasDead": false,
                            "wasS2": false,
                            "multiplierOccurrence": 0,
                            "cutRecord": [
                                false,
                                false,
                                false,
                                false,
                                false
                            ]
                        }
                    ],
                    [
                        {
                            "sym": "M1",
                            "symFrom": "M1",
                            "symTo": "M1",
                            "size": 1,
                            "multiplier": 1,
                            "wasDead": false,
                            "wasS2": false,
                            "multiplierOccurrence": 0,
                            "cutRecord": [
                                false,
                                false,
                                false,
                                false,
                                false
                            ]
                        }
                    ]
                ]
            ],
            "mysterySymbolRevealed": "L2",
            "multiplierOnReels": [
                0,
                0,
                0,
                0,
                0
            ],
            "xholeMultiplierOnXnudge": [
                0,
                0,
                0,
                0,
                0
            ],
            "firstS2FeatureTriggered": [
                "M3"
            ],
            "secondS2FeatureTriggered": [],
            "xholeCoordMap": [],
            "finalEvaluatedAreaAfterXhole": [],
            "lockedFrameBefore": [
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ]
            ],
            "stickyDeadSymCounter": {},
            "stickyDeadSymCounterNextSpin": {},
            "lockedS2inSFS": [],
            "outcomeFlagForQA": "",
            "outcomeFlagReelsForQA": [
                null,
                null,
                null,
                null,
                null
            ],
            "serverVersionQA": "2024.02.14.b"
        };
    }

    public init(): Promise<NolimitPlugin> {
        return super.init().then((value: NolimitPlugin) => {
            Game.model = new Model(SlotGame.apiPlugin, true);
            Game.gameFlowController = new GameFlowController(SlotGame.apiPlugin, Game.model);
            Game.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            const winPres = new WinPresentation();
            const idleNormal = new IdleNormalPresentation();
            const reelStart = new NormalBetPresentation();
            const normalResult = new NormalResultPresentation();
            const zeroBetIdle = new ZeroBetIdlePresentation();
            Game.idleNormalPresentation = idleNormal;

            Game.gameFlowController.addGameModeFlowStatePresentationMap(GameFeatureMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, idleNormal],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));
            Game.gameFlowController.addGameModeFlowStatePresentationMap(GameFeatureMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));
            Game.gameFlowController.addGameModeFlowStatePresentationMap(GameFeatureMode.RESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));
            Game.gameFlowController.addGameModeFlowStatePresentationMap(GameFeatureMode.FREESPIN_COOL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));
            Game.gameFlowController.addGameModeFlowStatePresentationMap(GameFeatureMode.FREESPIN_SUPER, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));

            Game.apiPlugin.events.on(APIEvent.ACTION_SPINS_IS_ACTIVE, (data: any) => {
                if (data) {
                    Game.idleNormalPresentation.skip();
                }
            });
            this.handleSweepInit();
            return value;
        });
    }

    public getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        return super.getReady().then((value: NolimitPlugin) => {

            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);
            fontLoader.add(GimmeDanger.REGULAR);
            fontLoader.add(RussoOne.REGULAR);
            fontLoader.add(Titania.REGULAR);
            fontLoader.add(MyriadPro.REGULAR);

            AssetsConfig.addToAssetsConfig(GameAssets.RESOURCES_GROUPS);
            Game.assetLoader = new AssetLoader(Game.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const promises = Promise.all([fontLoader.load(), Game.assetLoader.load(ResourcesGroupName.MAIN), this.handleSweepGetReady()]);

            return promises.then((values: any) => {

                this.createViewsAndComponents();
                Game.soundPlayer.playSound(Sound.INTRO_HOSPITAL_LOOP, undefined, Number.MAX_VALUE);
                return value;
            });
        });
    }

    public getReadyToStart(): Promise<NolimitPlugin> {
        //Game assets loaded, waiting for user to start game.
        return super.getReadyToStart().then((value: NolimitPlugin) => {
            return value;
        });
    }

    public getPaytable(): Promise<string> {
        const templateLoader: TemplateLoader = new TemplateLoader(Game.apiPlugin.resources.getStaticRoot());

        templateLoader.add({
            name: "Paytable",
            url: "nolimit/screens/paytable.mustache"
        });

        let symbolDataValueData: ISymbolValues = this._defaultSymbolValues;
        if (Game.model.initData.symbolValues) {
            symbolDataValueData = Game.model.initData.symbolValues;
            Logger.logDev("Using symbolValues from INIT data");
        } else {
            Logger.logDev("Using default symbolValues");
        }

        const data1 = {
            skinPath: "screens/images/"
        };
        if (this.skinner.skinId != undefined) {
            data1.skinPath = `../resources/images/${this.skinner.skinId}/`;
        }
        const promise: Promise<string> = templateLoader.load().then((assets: TemplateAsset[]) => {
            for (let asset of assets) {
                if (asset.name === "Paytable" && asset.loadedData) {
                    for (let key in symbolDataValueData) {
                        let nameKey: string = key;
                        asset.loadedData = asset.loadedData.replace(`{{${key}}}`, Game.getSymbolString(nameKey, symbolDataValueData[key]))
                    }
                    const data = Object.assign(Game.apiPlugin.gameClientConfiguration);
                    for (let index: number = 0; index < Game.model.initData.featureBuyTimesBetValue.length; index++) {
                        const featureBuyTimesBetValue: FeatureBuyTimesBetValue = Game.model.initData.featureBuyTimesBetValue[index];
                        const searchString: string = featureBuyTimesBetValue.name + "_VALUE";
                        data[searchString] = featureBuyTimesBetValue.price;
                    }
                    if (asset.loadedData) {
                        asset.loadedData = asset.loadedData.replace(/{{skinPath}}/g, data1.skinPath);
                        asset.loadedData = Game.apiPlugin.translations.render(asset.loadedData, data);
                    }
                }
                return asset.loadedData;
            }
            throw new Error("Game could not load Paytable");
        }) as Promise<string>;
        return promise;
    }

    /**
     * User has pressed continue and the game starts.
     * **/
    public start(): Promise<NolimitPlugin> {
        return super.start().then((value: NolimitPlugin) => {
            Game.gameFlowController.start();
            Game.soundPlayer.playSound(Sound.CONTINUE_BUTTON);
            Game.soundPlayer.switchMusic(Game.model.data.nextMode); //#406
            Game.soundPlayer.stopSound(Sound.INTRO_HOSPITAL_LOOP);
            if (!Game.apiPlugin.isReplay && !Game.model.isRestore) {
                Game.postIntro.play();
            } else {
                Game.reelView.show();//showReel in replay
                Game.backgroundElements.setMode(Game.model.data.nextMode);
            }

            Game.stickyView.onRestore();
            return value;
        });
    }

    private createViewsAndComponents() {
        //Non views
        Game.soundPlayer = new Sound();

        //Static views
        Game.postIntro = new PostIntro();
        Game.lift = new Lift();
        Game.backgroundElements = new BackgroundElements();
        Game.effectsView = new EffectsView();
        Game.graphicsPool = new GraphicsPool();
        Game.reelView = new ReelsView();
        Game.enhancerView = new EnhancerView();
        Game.fsIntroView = new FSIntroView();
        Game.upgradeView = new UpgradeView();
        Game.fsOutroView = new FSOutroView();
        Game.totalWinView = new TotalWinView();
        Game.winWaysView = new WinWaysView();
        Game.fireFrameView = new FireFrameView();
        Game.winHighlightView = new WinHighlightView();
        Game.bigWinView = new BigWinView();
        Game.winCapView = new WinCapView();
        Game.anticipationView = new AnticipationView();
        Game.sfsIntroView = new SFSIntroView();
        Game.sfsOutroView = new SFSOutroView();
        Game.cfsIntroView = new CFSIntroView();
        Game.cfsOutroView = new CFSOutroView();
        Game.foregroundElements = new ForeGroundElements();
        Game.stickyView = new StickyView();

        NolimitApplication.addLayerAt(Game.winCapView.name, Game.winCapView, 0);
        NolimitApplication.addLayerAt(Game.lift.name, Game.lift, 0);
        NolimitApplication.addLayerAt(Game.sfsOutroView.name, Game.sfsOutroView, 0);
        NolimitApplication.addLayerAt(Game.cfsOutroView.name, Game.cfsOutroView, 0);
        NolimitApplication.addLayerAt(Game.fsOutroView.name, Game.fsOutroView, 0);
        NolimitApplication.addLayerAt(Game.sfsIntroView.name, Game.sfsIntroView, 0);
        NolimitApplication.addLayerAt(Game.cfsIntroView.name, Game.cfsIntroView, 0);
        NolimitApplication.addLayerAt(Game.fsIntroView.name, Game.fsIntroView, 0);
        NolimitApplication.addLayerAt(Game.upgradeView.name, Game.upgradeView, 0);
        NolimitApplication.addLayerAt(Game.bigWinView.name, Game.bigWinView, 0);
        NolimitApplication.addLayerAt(Game.totalWinView.name, Game.totalWinView, 0);
        NolimitApplication.addLayerAt(Game.effectsView.name, Game.effectsView, 0);
        NolimitApplication.addLayerAt(Game.winWaysView.name, Game.winWaysView, 0);
        NolimitApplication.addLayerAt(Game.winHighlightView.name, Game.winHighlightView, 0);
        NolimitApplication.addLayerAt(Game.fireFrameView.name, Game.fireFrameView, 0);
        NolimitApplication.addLayerAt(Game.foregroundElements.name, Game.foregroundElements, 0);
        NolimitApplication.addLayerAt(Game.stickyView.name, Game.stickyView, 0);
        NolimitApplication.addLayerAt(Game.anticipationView.name, Game.anticipationView, 0);
        NolimitApplication.addLayerAt(Game.enhancerView.name, Game.enhancerView, 0);
        NolimitApplication.addLayerAt(Game.reelView.name, Game.reelView, 0);
        NolimitApplication.addLayerAt(Game.postIntro.name, Game.postIntro, 0);
        NolimitApplication.addLayerAt(Game.blackBG.name, Game.blackBG, 0);
        NolimitApplication.addLayerAt(Game.backgroundElements.name, Game.backgroundElements, 0);
    }
}